import { motion } from "framer-motion";
import React from "react";
interface Props {
  className?: string;
  children: React.ReactNode;
  isLoading: boolean;
}

export const ShimmerLoader: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <motion.div
      className={`${className ?? ""} bg-gray-200 rounded`}
      animate={{
        background: ["#f0f0f0", "#e0e0e0", "#f0f0f0"],
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: "linear",
      }}
    />
  );
};
export const Shimmer: React.FC<Props> = ({ className, children, isLoading }) => {
  return isLoading ? (
    <motion.div
      className={`${className} bg-gray-200 rounded`}
      animate={{
        background: ["#f0f0f0", "#e0e0e0", "#f0f0f0"],
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: "linear",
      }}
    />
  ) : (
    children
  );
};

interface ShimmerTableProps {
  rows?: number;
}

export const ShimmerTable: React.FC<ShimmerTableProps> = ({ rows = 10 }) => {
  const columns = ["Employee ID", "Employee Name", "Email", "Status", "Type", "Department", "Designation"];

  return (
    <div className="overflow-x-auto border rounded-lg shadow-sm">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="w-4 p-3">
              <ShimmerLoader className="h-4 w-4" />
            </th>
            {columns.map((_, i) => (
              <th key={i} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                <ShimmerLoader className="h-4 w-24" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {[...Array(rows)].map((_, i) => (
            <tr key={i} className="bg-white">
              <td className="p-3">
                <ShimmerLoader className="h-4 w-4" />
              </td>
              {columns.map((_, j) => (
                <td key={j} className="px-4 py-2">
                  <ShimmerLoader className="h-4 w-full" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const DashboardCardSkeleton = () => (
  <div className="animate-pulse bg-white rounded-md px-4 w-full md:w-[250px] h-[150px] flex justify-center items-center">
    <div className="flex flex-col gap-2 items-center relative w-full">
      <div className="h-[150px] md:h-20 w-full md:w-44 bg-gray-300 rounded" />
      <div className="h-20 md:h-10 w-[calc(100%-30px)] md:w-36 bg-gray-200 rounded absolute top-1/2 -translate-y-1/2" />
    </div>
  </div>
);

export const ActivityCardSkeleton = () => (
  <div className="animate-pulse flex gap-1 items-center rounded-md px-4 bg-white shadow-sm h-[80px]">
    <div className="size-12 bg-gray-300 rounded-full" />
    <div className="flex-1 flex flex-col justify-center gap-2 ml-3">
      <div className="h-10 w-3/4 bg-gray-300 rounded" />
      <div className="h-6 w-1/4 bg-gray-200 rounded" />
    </div>
  </div>
);

export const DashboardSkeleton = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 w-full">
    {[...Array(5)].map((_, i) => (
      <DashboardCardSkeleton key={i} />
    ))}
  </div>
);
